import { render, staticRenderFns } from "./ConsoleLink.vue?vue&type=template&id=b9742ef6&"
import script from "./ConsoleLink.vue?vue&type=script&lang=js&"
export * from "./ConsoleLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports